<div class="left-content" [class.grow]="left?.grow"><ng-content select="vdr-ab-left"></ng-content></div>
<div class="right-content" [class.grow]="right?.grow"><ng-content select="vdr-ab-right"></ng-content></div>
